module.exports = __webpack_public_path__ + "static/media/right-arrow-slider.345a72c3.svg";